(() => {
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency,
    }).format(Number(cents || 0) / 100);
  };

  const initUsaFlag = (section) => {
    if (!section || section.dataset.usaFlagReady === "true") return;
    section.dataset.usaFlagReady = "true";

    const sizeRadios = [
      ...section.querySelectorAll(
        'input[type="radio"][name="options[Size]"]',
      ),
    ];
    const sizeOutput = section.querySelector("[data-usa-size-output]");
    const poleOutput = section.querySelector("[data-usa-pole-output]");
    const poleQuote = section.querySelector("[data-usa-pole-quote]");
    const variantInput = section.querySelector("[data-product-variant]");
    const price = section.querySelector("[data-product-price]");
    const submit = section.querySelector('button[type="submit"]');
    const submitLabel = section.querySelector("[data-product-submit-label]");

    let variants = [];
    try {
      variants = JSON.parse(
        section.querySelector("[data-product-variants]")?.textContent || "[]",
      );
    } catch {
      variants = [];
    }

    const update = () => {
      const selected = sizeRadios.find((radio) => radio.checked);
      if (!selected) return;

      const size = selected.value;
      const pole = selected.dataset.usaPoleMatch || "project specification";
      const variant = variants.find((candidate) => candidate.option1 === size);
      const orderable =
        Boolean(variant?.available) && Number(variant?.price || 0) > 0;

      if (sizeOutput) sizeOutput.textContent = size.toUpperCase();
      if (poleOutput) poleOutput.textContent = pole.toUpperCase();
      if (variantInput && variant) variantInput.value = variant.id;
      if (price) {
        price.textContent =
          variant && Number(variant.price) > 0
            ? money(variant.price)
            : "PRICING CONFIRMATION REQUIRED";
      }
      if (submit) submit.disabled = !orderable;
      if (submitLabel) {
        submitLabel.textContent = orderable
          ? "ADD USA FLAG TO CART"
          : "PRICING / AVAILABILITY PENDING";
      }

      if (poleQuote) {
        const base =
          poleQuote.dataset.quoteBase ||
          poleQuote.getAttribute("href") ||
          "/pages/contact";
        const destination = new URL(base, window.location.origin);
        destination.searchParams.set("product", "Flagpole Specification");
        destination.searchParams.set("flag_size", size);
        destination.searchParams.set("source", "reinforced-usa-flag");
        poleQuote.href = `${destination.pathname}${destination.search}${destination.hash}`;
      }
    };

    sizeRadios.forEach((radio) => radio.addEventListener("change", update));
    update();
  };

  const initialize = (root = document) => {
    root
      .querySelectorAll("[data-gameday-usa-flag]")
      .forEach((section) => initUsaFlag(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize());
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });
})();
